import { createContext, useContext } from "react";

/** What the comments panel was opened on. */
export interface DocumentCommentsPanelTarget {
  documentId: number;
  buildingId: number;
  filename: string;
  /** Scroll to and highlight this thread once loaded (deep links). */
  initialThreadId?: number | null;
}

export interface DocumentCommentsPanelApi {
  /** Slide the comments panel in over the list for this document. */
  open: (target: DocumentCommentsPanelTarget) => void;
  /**
   * Deep link: resolve the thread, open its document in the viewer with the
   * rail on that thread (or the panel, for a file with no preview). Toasts
   * when the thread is not visible to the caller.
   */
  openThread: (threadId: number) => Promise<void>;
  /** Open a document in the viewer, on a page. */
  openDocumentAtPage: (documentId: number, page: number | null) => Promise<void>;
}

export const DocumentCommentsPanelContext = createContext<DocumentCommentsPanelApi | null>(null);

/**
 * The page's comments panel, or `null` when no provider is mounted (the public
 * share page, the container dialog) — callers then offer no Comments action.
 */
export function useDocumentCommentsPanel(): DocumentCommentsPanelApi | null {
  return useContext(DocumentCommentsPanelContext);
}
